import { render, staticRenderFns } from "./BookingOrderTable.vue?vue&type=template&id=675018a6&scoped=true"
import script from "./BookingOrderTable.vue?vue&type=script&lang=js"
export * from "./BookingOrderTable.vue?vue&type=script&lang=js"
import style0 from "./BookingOrderTable.vue?vue&type=style&index=0&id=675018a6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675018a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('675018a6')) {
      api.createRecord('675018a6', component.options)
    } else {
      api.reload('675018a6', component.options)
    }
    module.hot.accept("./BookingOrderTable.vue?vue&type=template&id=675018a6&scoped=true", function () {
      api.rerender('675018a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods_activity/booking/BookingOrderTable.vue"
export default component.exports